import { render, staticRenderFns } from "./GrantConditions.vue?vue&type=template&id=4c5bc7f3&scoped=true&"
import script from "./GrantConditions.vue?vue&type=script&lang=js&"
export * from "./GrantConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bc7f3",
  null
  
)

export default component.exports